<template>
	<b-overlay :show='isSendingBlocked' :opacity='0.5'>
		<b-form @submit.stop.prevent='onSubmit'>
			<b-form-group label='Тема'>
				<b-form-input v-model='subject' required placeholder='введите тему сообщения'>
				</b-form-input>
			</b-form-group>

			<b-form-group label='Сообщение'>
				<b-form-textarea v-model='message' required placeholder='введите сообщение' rows='6'>
				</b-form-textarea>
			</b-form-group>

			<b-form-group label='Пользователь'>
				<b-form-input disabled :value='user ? user.name : "нет данных"'>
				</b-form-input>
			</b-form-group>

			<hr>
	 
			<b-alert :show='dismissCountdownSuccess' variant="success" dismissible @dismissed='dismissCountdownSuccess = 0'>Сообщение успешно отправлено</b-alert>
			<b-alert :show='dismissCountdownError' variant="danger" dismissible @dismissed='dismissCountdownError = 0'>При отправке сообщения произошла ошибка</b-alert>

			<div class='btn-row'>
				<b-button variant='danger' @click='cancel' class='mr-2'>Отмена</b-button>
				<b-button type='submit' variant='success'>Отправить</b-button>
			</div>

		</b-form>
	</b-overlay>

</template>

<script>
	import { mapState } from 'vuex';

	const MAIL_SEND = process.env.VUE_APP_ROOT_API + 'tech_support_send_mail.php';

	export default {
		name: 'SupportFormComponent',
		data() {
			return {
				subject: null,
				message: null,

				alertError: false,
				alertSuccess: false,

				isSendingBlocked: false,

				dismissCountdownSuccess: 0,
				dismissCountdownError: 0,
			};
		},
		computed: {
			...mapState('user', {
				user: state => state.user
			})
		},
		methods: {
			cancel() {
				this.$emit('cancel');
			},

			onSubmit() {
				console.log('submit');
				this.sendMail();
			},

			sendMail() {
				if (this.isSendingBlocked) {
					return;
				}

        // this.error = null;
        // this.success = null;

        const form = new FormData();
        form.append('user_id', this.user.id);
        form.append('subject', this.subject)
        form.append('body', this.message);

        this.isSendingBlocked = true;

        fetch(MAIL_SEND, {
          credentials: 'include',
          method: 'post',
          body: form
        })
        .then(res => res.json())
        .then(res => {
          if (res.code == 0) {
          	// this.success = 'Сообщение отправлено';

          	this.dismissCountdownSuccess = 4;

          	// setTimeout(() => { this.success = null; }, 4000);
          }
          else {
          	// this.error = 'Ошибка при отправке сообщения';
          	this.dismissCountdownError = 4;

          }
        })
        .catch(err => console.log(err))
        .finally(() => { this.isSendingBlocked = false; })
      }
		}
	};
</script>

<style scoped>
	.btn-row {
		display: flex;
		justify-content: flex-end;
	}
</style>

<style scoped>

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 20px;
}
.lds-ellipsis div {

  position: absolute;
  top: 8px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #aaa;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>